import React from 'react';

const HomePage = () => (
  <div data-testid="homePageContent" className="border">
    <h2 className="headerText">Welcome to our page!</h2>
    <p className="homePageParagraph">
      Lorem ipsum dolor sit amet, consectetur adipiscing elit.
      Nunc luctus magna in tellus convallis pellentesque.
      Curabitur felis est, convallis at ipsum sit amet, placerat ultricies justo.
      In purus urna, vehicula nec consectetur a, eleifend ut eros.
      Fusce sit amet eleifend ex, bibendum rutrum metus.
      Phasellus urna lorem, tempor quis metus finibus, faucibus gravida augue.
      Sed non ipsum tristique augue sollicitudin accumsan.
      Nunc vitae tincidunt nibh, quis ultricies eros.
      In hac habitasse platea dictumst.
      Nulla eros lacus, commodo in molestie ut, dapibus non orci.
      Aenean placerat ex congue, fermentum nisi porttitor, vehicula nunc.
      Quisque ac commodo augue.
      Morbi posuere mi nec leo sollicitudin, et commodo tortor ultricies.
    </p>
  </div>
);

export default HomePage;
